import script from "./OptionalExternalIcon.vue?vue&type=script&lang=js"
export * from "./OptionalExternalIcon.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__